/**
 * @file paddle Wave Summit 2020 现场颁奖典礼
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo} from 'react';
import {Col, Row} from 'antd';
import {IAwardsCeremonyProps} from './types';
import A from '../../../../components/a/A';


const AwardsCeremony: React.FC<IAwardsCeremonyProps> = (props) => {
    const explainList = useMemo(() => {
        return props.explainList || [];
    }, [props.explainList]);

    const prize = useMemo(() => {
        return props.prize || [];
    }, [props.prize]);

    return (
        <div className="paddle-ws2020-ac">
            {explainList.map((item, index) => (
                <div key={index} className="paddle-ws2020-ac-line">
                    <i className="paddle-ws2020-ac-start-icon" />
                    <span {...{dangerouslySetInnerHTML: {__html: item}}} />
                </div>
            ))}

            <div className="paddle-ws2020-ac-picture-list">
                <Row gutter={[34, 34]}>
                    {prize.map((item, index) => (
                        <Col xs={24} sm={8} md={4} key={index}>
                            <A
                                className="paddle-ws2020-ac-picture-card"
                                target
                                href={item.link}
                            >
                                <div className="paddle-ws2020-ac-picture-card-img-wrap">
                                    <div className="paddle-ws2020-ac-picture-card-img-inner">
                                        <div
                                            className="paddle-ws2020-ac-picture-card-img"
                                            style={{backgroundImage: item.imageUrl ? `url(${item.imageUrl})` : undefined}}
                                        />
                                    </div>
                                </div>
                                <div className="paddle-ws2020-ac-picture-card-title">
                                    {item.title}
                                </div>
                            </A>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default AwardsCeremony;
